import { Box } from "@mui/material";
import ReconditioningProcessComponent from "../../components/ReconditioningProcessComponent/ReconditioningProcessComponent";
import DashboardLayout from "../../Layout/DashboardLayout/DashboardLayout";
import { Helmet } from "react-helmet";
import TagManager from "react-gtm-module";
import { useEffect } from "react";
import ReconditioningProcessComponentV2 from "../../components/ReconditioningProcessComponent/ReconditioningProcessComponentV2";

const ReconditioningProcessV2 = () => {
  useEffect(() => {
    const tagManagerArgs = {
      gtmId: "G-VWGPB9LR1K", // Replace with your Google Tag Manager ID
      dataLayerName: "PageDataLayer",
      dataLayer: {
        page: window.location.pathname,
      },
    };
    TagManager.initialize(tagManagerArgs);
  }, []);
  return (
    <>
      <Helmet>
        <title>Equipment Reconditioning & Rebuilding | Marcel Equipment</title>
        <link rel="icon" href="/favicon.ico" type="image/x-icon" />
        <meta
          name="description"
          content="Learn about Marcel Equipment's reconditioning & rebuilding process for used construction & landfill equipment. Each machine performs like new before listing."
        />
      </Helmet>
      <DashboardLayout activeTab={"ReconditioningProcess"}>
        <Box>
          <ReconditioningProcessComponentV2 />
        </Box>
      </DashboardLayout>
    </>
  );
};
export default ReconditioningProcessV2;
